import { Mutation, Action } from 'vuex-module-decorators';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { Resolve } from 'vue-di';
import { SurveySessionValueModel,EnrollmentSurveyQuestionModel } from '@trialcard/apigateway.models';
import SessionModule from './session';
import { Settings } from '~/services/settings';

export interface IEligibilityQuestions {
    surveySessionId: string;
    questionId: number;
    answerId: number;
}
@InjectModule({ stateFactory: true }, module)
export default class EligibilityModule extends InjectVuexModule {
    @Resolve
    public settings!: Settings;

    @Resolve
    public session!: SessionModule;
    public eligibilityData = [] as SurveySessionValueModel[];
    public eligibilityInsuredData = [] as EnrollmentSurveyQuestionModel[];
    public uninsuredPatientAuth = []  as EnrollmentSurveyQuestionModel[];
    public insuredPatientAuth = []  as EnrollmentSurveyQuestionModel[];
    public eligibilityUninsuredData = [] as EnrollmentSurveyQuestionModel[];
    public isEligible = false;

    @Mutation
    public  updateEligibilityData(newEligibilityData: typeof EligibilityModule.prototype.eligibilityInsuredData) {
        this.eligibilityData = newEligibilityData;
    }
    @Mutation
    public  updateEligibilityInsuredData(newEligibilityData: EnrollmentSurveyQuestionModel[]) {
        this.eligibilityInsuredData = newEligibilityData;
    }

    @Mutation
    public  updateInsuredPatientAuthData(newEligibilityData: EnrollmentSurveyQuestionModel[]) {
        this.insuredPatientAuth = newEligibilityData;
    }

    @Mutation
    public  updateEligibilityUninsuredData(newEligibilityData:  EnrollmentSurveyQuestionModel[]) {
        this.eligibilityUninsuredData = newEligibilityData;
    }

    @Mutation
    public  updateUninsuredPatientAuthData(newEligibilityData: EnrollmentSurveyQuestionModel[]) {
        this.uninsuredPatientAuth = newEligibilityData;
    }

    @Mutation
    public  updateIsEligible(isEligible: boolean) {
        this.isEligible = isEligible;
    }

    @Action({ rawError: true })
    public async clearStore() {
        this.updateEligibilityData([]);
        this.updateEligibilityInsuredData([]);
        this.updateEligibilityUninsuredData([]);
        this.updateIsEligible(false);
    }
    @Action({ rawError: true })
    public checkEligibilityUninsuredPath(): boolean {
        const correctAnswers = [
            +this.settings.uninsuredPathAnswerId,
            +this.settings.uninsuredOfferAnswerId,
            +this.settings.uninsuredEligibilityAgeAnswerYes,
            +this.settings.uninsuredEligibilitySubsidizedHealthcareAnswerYes,
            +this.settings.uninsuredEligibilityIsPrescribedOmnitropeAnswerYes,
            +this.settings.uninsuredEligibilityLabelIndicationGHD,
            +this.settings.uninsuredEligibilityLabelIndicationISS ,
            +this.settings.uninsuredEligibilityLabelIndicationSGA,
            +this.settings.uninsuredEligibilityLabelIndicationTS ,
            +this.settings.uninsuredEligibilityLabelIndicationPWS ,
            +this.settings.uninsuredEligibilityLabelIndicationGHD2 ,
        ] as number[];
        const isEligible =  this.eligibilityUninsuredData.every(question => question.answerKey && correctAnswers.includes(question.answerKey));
        this.updateIsEligible(isEligible);
        return isEligible;
    }

    @Action({ rawError: true })
    public  checkEligibilityInsuredPath(): boolean {
        const correctAnswers = [
            +this.settings.insuredPathAnswerId,
            +this.settings.insuredEligibilityAgeAnswerYes,
            +this.settings.insuredEligibilitySubsidizedHealthcareAnswerYes,
            +this.settings.insuredEligibilityIsPrescribedOmnitropeAnswerYes,
            +this.settings.insuredEligibilityLabelIndicationGHD,
            +this.settings.insuredEligibilityLabelIndicationISS ,
            +this.settings.insuredEligibilityLabelIndicationSGA,
            +this.settings.insuredEligibilityLabelIndicationTS ,
            +this.settings.insuredEligibilityLabelIndicationPWS ,
            +this.settings.insuredEligibilityLabelIndicationGHD2 ,
        ] as number[];
        const isEligible = this.eligibilityInsuredData.every(question => question.answerKey && correctAnswers.includes(question.answerKey));
        this.updateIsEligible(isEligible);
        return isEligible;
    }
}
